import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class RiskAnalyticsService {
    static getMetricData(stdId,date) {
        return HttpUtil.get(
          API_ROUTES.RISK.GETMETRICDATA.replace("<standardId>", stdId).replace("<date>", date)
        );
      }

    static getMetricDetailsTable(stdId, metricId, date) {
        return HttpUtil.get(
            API_ROUTES.RISK.GETMETRICDETAILSTABLE.replace("<standardId>", stdId).replace("<metricId>",metricId).replace("<date>", date)
        );
    }
      
}